module.exports = __webpack_public_path__ + "media/shelter_materials/shelter_banner_large_1x-46605408.png";